import script from "./Web3WalletButton.vue?vue&type=script&setup=true&lang=js"
export * from "./Web3WalletButton.vue?vue&type=script&setup=true&lang=js"

import "./Web3WalletButton.vue?vue&type=style&index=0&id=53df11d2&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53df11d2"]])

export default __exports__